import React, { useState } from 'react';
import { Tag } from '@wix/design-system';
export const VisualTemplateTag = _ref => {
  let {
    title,
    template,
    setSelectedStyles,
    disabled,
    index
  } = _ref;
  const [isSelected, setSelected] = useState(false);
  const selectionHandler = () => {
    if (!template) {
      return;
    }
    setSelectedStyles(prevStyles => isSelected ? prevStyles.filter(style => style !== template) : [...prevStyles, template]);
    setSelected(!isSelected);
  };
  return /*#__PURE__*/React.createElement(Tag, {
    size: "medium",
    id: title,
    removable: false,
    skin: isSelected ? 'standard' : disabled ? 'neutral' : 'lightOutlined',
    key: index,
    onClick: !disabled || isSelected ? selectionHandler : undefined
  }, title);
};
//# sourceMappingURL=VisualTemplateTag.js.map